module.exports = __webpack_public_path__ + "img/ic_32_sport_basketball-active.bd5ebc6b.svg";